<template>
  <transition name="modal">
    <modal
      v-if="isCreatingModalShow"
      class="creating-modal"
      :redesign="true"
      @close="toggleCreatingModal(false)"
    >
      <div slot="header">{{ $tr('vacancy.create.newVacancy') }}</div>
      <div slot="body">
        <div class="creating-modal__block">
          <label>{{ $tr('vacancy.create.selectLanguage') }}</label>

          <languages-select v-model="language" :has-label="false" />
        </div>

        <div class="creating-modal__block">
          <input
            v-model="vacancyName"
            :placeholder="$tr('vacancy.preferences.settings.vacancyName')"
            type="text"
            @input="replaceSymbols($event)"
          />
        </div>
      </div>
      <div slot="footer">
        <vbutton label="common.cancel" color="grey" @click="toggleCreatingModal(false)" />

        <vbutton
          :loading="creationLoading"
          :disabled="
            isVacancyCreationDisabled || !(!!language && language.id) || !isVacancyNameValid
          "
          label="common.ok"
          @click="createVacancy"
        />
      </div>
    </modal>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Modal from '@/components/Modal';
const LanguagesSelect = () => import('@/components/vacancy/preferences/SettingsLanguagesSelect');
import { LANGUAGES_LIST } from '@/_helpers/constants';

export default {
  components: {
    Modal,
    LanguagesSelect
  },

  data() {
    return {
      creationLoading: false,
      vacancyName: '',
      vacancy_language: {
        code: null,
        id: null,
        name: null
      },

      languages: LANGUAGES_LIST
    };
  },

  computed: {
    ...mapState('vacancy', ['new_vacancy_id']),

    ...mapState('vacancies', ['isCreatingModalShow']),

    ...mapState('company_new', ['rates']),

    isVacancyNameValid() {
      return this.vacancyName && !!this.vacancyName.trim();
    },

    isVacancyCreationDisabled() {
      if (!this.rates) {
        return 0;
      }

      return this.rates.vacancy_balance !== null && this.rates.vacancy_balance <= 0;
    },

    language: {
      get() {
        if (this.vacancy_language && this.vacancy_language.id === null) {
          return this.languages.find(item => item.code === this.locale);
        }

        return this.vacancy_language;
      },

      set(val) {
        this.vacancy_language = val;
      }
    }
  },

  methods: {
    ...mapMutations('vacancies', ['SET_IS_CREATING_MODAL_SHOW']),

    toggleCreatingModal(val) {
      this.SET_IS_CREATING_MODAL_SHOW(val);

      if (!val) {
        this.vacancy_language = {
          code: null,
          id: null,
          name: null
        };
        this.vacancyName = '';
      }
    },

    replaceSymbols(e) {
      let value = e.target.value;

      let replacedValue = value.replace(/[`~!@#$%^&*()_|+=?;:..’“'"<>,€£¥•،٫؟»«{}[\]\\/]+/gi, '');
      this.vacancyName = replacedValue;
    },

    async createVacancy() {
      if (!this.language || !this.language.id) {
        return;
      }

      const title = this.vacancyName.trim();
      this.creationLoading = true;

      await this.$store
        .dispatch('vacancy/store', { title, language_id: this.language.id })
        .then(() => {
          this.$router.push({ path: `/vacancies/${this.new_vacancy_id}` });
        })
        .then(() => {
          if (window.gtag) {
            window.gtag({ event: 'vacancy_created' });
          }
        })
        .finally(() => {
          this.creationLoading = false;
          this.toggleCreatingModal(false);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/fonts.scss';

.creating-modal {
  .modal-wrapper .close-icon {
    right: 13px;
    top: 13px;
    font-size: 27px;
  }

  &__block {
    @include mixin-text-tag;
    font-size: 1em;
    padding-bottom: 15px;

    label {
      display: block;
      margin-bottom: 7px;
    }

    input {
      width: 100%;
    }
  }

  .modal-container {
    box-shadow: $box-shadow;
    border-radius: 2px;
    box-sizing: border-box;
    max-width: 450px;
    min-width: 450px;
    padding: 30px 40px 41px;

    .modal-header {
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 32px;
      color: $main-dark;
    }

    .modal-body {
      margin: 12px 0 30px;
    }

    .modal-footer {
      display: flex;
      justify-content: center;
    }

    .multiselect.big {
      width: 100%;
    }
  }
}
</style>
